<!-- HotFlag Popup -->
<button id="hotFlag_button_CloseModal" type="button" class="close" data-dismiss="modal" aria-label="Close" tabindex="-1" (click)="closeModal()">
  <span aria-hidden="true">&times;</span>
</button>
<div class="modal-header">
  <h4 class="modal-title me-2">Hot Flag</h4>
  <div class="input-group w-50 w-md-33">
    <input id="hotFlag_text_SearchFavoriteId" type="text" class="form-control customer-search-textbox" [(ngModel)]=filterKey
      (keyup)="filter()" placeholder="Search...">
      <span class="input-group-text">
        <i class="fas fa-search" aria-hidden="true"></i>
      </span>
    </div>
  </div>
<div class="modal-body" *ngLet="{
  fixedVendor: fixedVendor$ | async,
  filteredCartItems: filteredCartItems$ | async,
  hotFlags: hotFlags$ | async,
  isHotFlagVinEnabled: isHotFlagVinEnabled$ | async,
  cartItemsWithVendorPrices: cartItemsWithVendorPrices$ | async
} as vm">
    <div id="hotFlag_div_Procurement" class="gy-2">
      <form id="hotFlag_form_HotFlagForm" [formGroup]="form">
        <div ngbAccordion #acc="ngbAccordion" class="accordion-sm gy-1" [closeOthers]="true" formArrayName="cartItems">
          @for (cartItem of vm.filteredCartItems; track (cartItem.cartItemId ?? cartItem.bctId) + '-' + (cartItem.isSplit ?? false); let i = $index) {
            @let formIndex = getFormIndexByCartItem(cartItem);
            <div
              ngbAccordionItem="hotFlag_panel_HotFlag_{{formIndex}}"
              #accItem="ngbAccordionItem"
              [destroyOnHide]="false"
              (hidden)="lastExpandedIndex = null"
              (shown)="onAccordionShown(formIndex)"
              [collapsed]="lastExpandedIndex !== formIndex"
              [formGroupName]="formIndex">
              <div ngbAccordionHeader class="bg-header">
                <button ngbAccordionToggle type="button" class="btn accordion-toggle">
                  <div class="d-flex">
                    <div class="px-2">
                      <div>
                        <i class="fas" [ngClass]="accItem.collapsed ? 'fa-plus' : 'fa-minus'" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="flex-grow-1 px-3 text-start gx-3">
                      <span class="gx-1">
                        @if (getCartItemControls(formIndex)?.hotFlagCode.errors?.required) {
                          <i id="hotFlag_i_HotFlagIsRequired_{{formIndex}}" title="Hot Flag is required." class="fas fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                        }
                        @if (getVINControl(formIndex)?.errors?.required && getCartItemControls(formIndex)?.hotFlagCode?.value?.length > 0) {
                          <i id="hotFlag_i_VINIsRequired_{{formIndex}}" title="VIN is required." class="fas fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                        }
                        @if (getVINControl(formIndex)?.errors?.pattern) {
                          <i id="hotFlag_i_VINIsInvalid_{{formIndex}}" title="VIN is invalid." class="fas fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                        }
                        @if (getCartItemControls(formIndex)?.esn.errors?.required || getCartItemControls(formIndex)?.esn.errors?.minlength) {
                          <i
                            id="hotFlag_i_ESNRequired_{{formIndex}}"
                            title="ESN is required, 8-30 characters."
                            class="fas fa-exclamation-triangle text-danger"
                          aria-hidden="true"></i>
                        }
                        <b>Part Number:</b>
                        <span>{{cartItem.partNumber}}</span>
                      </span>
                      <span class="gx-1">
                        <b>Vendor Number:</b>
                        @if (cartItem.vendorCode) {
                          <span id="hotFlag_span_VendorCode_{{formIndex}}">{{cartItem.vendorCode | rewardNumber}}</span>
                        }
                      </span>
                    </div>
                    <div class="ms-auto">
                      <button id="hotFlag_button_RemoveCartItem_{{formIndex}}" style="background: transparent; border: none !important;" (click)="removeCartItem(cartItem)">
                        <i class="fas fa-times text-danger" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </button>
              </div>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="row align-items-center pb-3">
                      <div class="col-sm-3 strong" id="hotFlag_div_selectHotflag">Select Hot Flag</div>
                      <div class="col-sm-9">
                        <select
                          id="hotFlag_select_cartItemHotFlag_{{formIndex}}"
                          name="hotFlagCode"
                          class="form-control"
                          formControlName="hotFlagCode"
                          #hf
                          (change)="onHotFlagChange(formIndex, hf.value, cartItem.vendorCode, cartItem.knownPartPrice)">
                          <option value="">Please Select Hot Flag</option>
                          @for (flag of vm.hotFlags; track flag.code; let f = $index) {
                            <option id="hotFlag_select_flag.code_{{f}}" value="{{flag.code}}">{{flag.code}} - {{flag.description}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    @if (isVINControlVisible(formIndex, cartItem.vendorCode)) {
                      <div class="row align-items-center pb-3">
                        <div class="col-sm-3 strong">Enter VIN</div>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            vin
                            id="hotFlag_vin_cartItemHotFlag_{{formIndex}}"
                            maxlength="36"
                            class="form-control"
                            [class.is-invalid]="getVINControl(formIndex).invalid && getVINControl(formIndex).validator && (getVINControl(formIndex).touched || getVINControl(formIndex).dirty)"
                            [class.is-valid]="getVINControl(formIndex).valid && getVINControl(formIndex).value && getVINControl(formIndex).validator"
                            [formControl]="getVINControl(formIndex)"
                            (input)="vinUpdateSubject.next({event: $event, index: formIndex, vendorCode: cartItem.vendorCode})"
                            (blur)="trimVINValue(getVINControl(formIndex))"/>
                          </div>
                        </div>
                      }
                      @if (updateCumminsWithWarrantyVisibility(formIndex, cartItem.vendorCode)) {
                        <div class="row align-items-center pb-3">
                          <div class="col-sm-3 strong">ESN</div>
                          <div class="col-sm-9">
                            <input
                              type="text"
                              id="hotFlag_esn_cartItemHotFlag_{{formIndex}}"
                              maxlength="30"
                              class="form-control"
                              [class.is-invalid]="form.controls.cartItems.controls[formIndex].controls.esn.invalid && form.controls.cartItems.controls[formIndex].controls.esn.validator"
                              [class.is-valid]="form.controls.cartItems.controls[formIndex].controls.esn.valid && form.controls.cartItems.controls[formIndex].controls.esn.value && form.controls.cartItems.controls[formIndex].controls.esn.validator"
                              [formControl]="form.controls.cartItems.controls[formIndex].controls.esn"
                              (input)="esnUpdateSubject.next({event: $event, id: cartItem.cartItemId ?? cartItem.bctId, index: formIndex})"/>
                            </div>
                          </div>
                        }
                        @if (updateCumminsWithWarrantyVisibility(formIndex, cartItem.vendorCode)) {
                          <div class="row align-items-center pb-3">
                            <div class="col-sm-3 strong">Cummins RapidServe Control</div>
                            <div class="col-sm-9">
                              <input
                                type="text"
                                id="hotFlag_crc_cartItemHotFlag_{{formIndex}}"
                                maxlength="16"
                                class="form-control"
                                [formControl]="form.controls.cartItems.controls[formIndex].controls.crc"
                                (input)="crcUpdateSubject.next({event: $event, id: cartItem.cartItemId ?? cartItem.bctId, index: formIndex})"/>
                              </div>
                            </div>
                          }
                        </ng-template>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </form>
            <div>
              <button
                id="hotFlag_button_SendHotFlag"
                type="button"
                class="btn yellow-btn w-100 text-uppercase"
                [disabled]="!form.valid || vm.fixedVendor===false || isVINUpdating || selectedCartItemsLength === 0"
              (click)="sendHotFlags()">Send Hot Flag</button>
            </div>
            @if (!(form.valid && vm.fixedVendor)) {
              <div id="hotFlag_div_InvalidForm" class="alert alert-danger m-0">
                <div [hidden]="!hasHotFlagError" id="hot-flag-div-hot-flag-is-required">Hot Flag is required.</div>
                @if (vm.isHotFlagVinEnabled) {
                  @if (hasVINError && hasVINPatternError()) {
                    <p id="hotFlag_div_InvalidForm_vin_pattern" class="m-0">VIN is invalid. VIN can only contain alphanumeric characters.</p>
                  }
                  @if (hasVINError && hasVINRequiredError()) {
                    <p id="hotFlag_div_InvalidForm_vin_invalid" class="m-0">VIN is required, 1-36 characters.</p>
                  }
                  <p [hidden]="!hasESNError" id="hotFlag_div_InvalidForm_Esn_Rquired" class="m-0">ESN is required, 8-30 characters.</p>
                }
                <div [hidden]="vm.fixedVendor">{{partNumber}} cannot be procured, it does not have a fixed vendor. Send
                a request to PartAdds to add fixed vendor.</div>
              </div>
            }
          </div>
        </div>
        <!-- end HotFlag Popup-->
